import IllumiLogo from "@src/assets/illumi-logo-main.png";
import { AgentChatMenuBarEntry } from "@src/components/agent-chat/agent-chat-shell-entry";
import { TerminalsMenuBarEntry } from "@src/components/terminal/terminals-navbar-entry";
import { AnimatePresence, motion } from "framer-motion";
import { NavigationToggleButton } from "../navigation-toggle-button";
import { useMenuState } from "./menu-drawer";

export function MenuBar() {
	const isElectron = Boolean(window.electronAPI?.isElectron);

	return (
		<div className="px-1.5 py-1.5 flex flex-row w-full landscape:max-w-14 desktop-nav:h-full shadow-sm items-center desktop-nav:items-end z-(--illumi-z-index-navbar-menu) desktop-nav:hidden bg-surface-default">
			<NavigationToggleButton />

			<img
				src={IllumiLogo}
				alt="illum! logo"
				className="object-contain grow mr-10.5 h-8 landscape:hidden"
			/>

			<div className="ml-auto landscape:hidden flex items-center gap-1.5">
				{isElectron ? <TerminalsMenuBarEntry /> : null}
				<AgentChatMenuBarEntry />
			</div>
		</div>
	);
}

export function MenuDrawer(props: {
	children: React.ReactNode;
}) {
	const { isDrawerOpen } = useMenuState();

	return (
		<AnimatePresence>
			{isDrawerOpen && (
				<motion.div
					className="fixed inset-0 top-14 landscape:left-14 landscape:top-0 desktop-nav:top-0 desktop-nav:left-10 z-(--illumi-z-index-navbar-container) overflow-y-auto bg-surface-default desktop-nav:hidden"
					initial={{ x: "-100%" }}
					animate={{ x: 0 }}
					exit={{ x: "-100%" }}
					transition={{ duration: 0.1, type: "spring", bounce: 0 }}
				>
					{props.children}
				</motion.div>
			)}
		</AnimatePresence>
	);
}
